import { Page } from '@/components';
import TokensBaseTable from './Table';
export default function TokensOptimismPage() {
  return (
    <Page title="Tokens">
      <TokensBaseTable />
    </Page>
  );
}
